import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Loading from "../Layout/Loading";
import EntryFormContent from "./EntryFormContent";

const ViewDetails = ({ closeModal: parentCloseModal, selectedObject }) => {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  const [loading, setLoading] = useState(false);
  // Check if the screen is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640); // Same breakpoint as sm in Tailwind FIXME:
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      parentCloseModal();
    }, 400);
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <AnimatePresence>
        {isOpen &&
          (isMobile ? (
            // Mobile dialog (centered, no animation)
            <div
              ref={modalRef}
              className="bg-white w-[70vw] max-w-md rounded-lg max-h-[70vh] overflow-y-auto  shadow-lg"
            >
              {loading ? (
                <Loading />
              ) : (
                <div className="fixed inset-0 flex items-center justify-center z-30">
                  <div
                    className="fixed inset-0 bg-black opacity-50"
                    onClick={closeModal}
                  ></div>
                  <div className="bg-white rounded-lg py-3 px-2 z-50 w-[85vw] max-w-md mx-4 relative h-4/6">
                    {/* X button positioned in the top right corner */}
                    <button
                      onClick={closeModal}
                      className="absolute -top-9 -right-4 bg-gray-200 rounded-full p-1 hover:bg-gray-300 "
                    >
                      <X className="w-5 h-5 text-gray-500 hover:text-gray-800" />
                    </button>

                    <EntryFormContent selectedObject={selectedObject} />
                  </div>
                </div>
              )}
            </div>
          ) : (
            // Desktop slide-in panel
            <motion.div
              ref={modalRef}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.4 }}
              className="bg-white max-w-[900px] w-[80vw] h-full px-2 absolute right-0 top-0 shadow-lg"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <button
                    onClick={closeModal}
                    className="absolute top-0 -left-12 bg-gray-200 rounded-md p-1 shadow-md"
                  >
                    <X className="w-7 h-7 text-gray-500 hover:text-gray-800" />
                  </button>
                  <div className="pt-4">
                    <EntryFormContent selectedObject={selectedObject} />
                  </div>
                </>
              )}
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default ViewDetails;
